module.exports = __webpack_public_path__ + "img/logo_common.7e853f20.svg";